import React from "react";
import "./styles.scss";
import LightModeIcon from "../../assets/lightIcon.png";
import DarkModeIcon from "../../assets/darkIcon.png";
import { useDispatch, useSelector } from "react-redux";
import { themActions } from "../../redux/actions/AuthAction";
import { themModeSelector } from "../../redux/selectors/AuthSelectors";

const Mode = () => {
  const { isDarkMode } = useSelector(themModeSelector);
  const dispatch = useDispatch();

  return (
    <div className="mode-wrapper">
      {!isDarkMode ? (
        <img
          src={DarkModeIcon}
          className="them-mode-icon"
          onClick={() => dispatch(themActions(true))}
        />
      ) : (
        <img
          src={LightModeIcon}
          className="them-mode-icon"
          onClick={() => dispatch(themActions(false))}
        />
      )}
    </div>
  );
};
export default Mode;
